const GERMAN_DATE = /^(\d{1,2})\.(\d{1,2})\.(\d{4})$/;
const ISO_DATE = /^(\d{4})-(\d{2})-(\d{2})$/;

type CalendarDate = {
  year: number;
  month: number;
  day: number;
};

function isCalendarDate({ year, month, day }: CalendarDate): boolean {
  if (year < 1 || month < 1 || month > 12 || day < 1) return false;

  const leapYear = year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
  const daysInMonth = [31, leapYear ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  return day <= daysInMonth[month - 1];
}

function parseFactDate(value: string): CalendarDate | null {
  const input = value.trim();
  const german = GERMAN_DATE.exec(input);
  const iso = ISO_DATE.exec(input);

  const parsed = german
    ? { year: Number(german[3]), month: Number(german[2]), day: Number(german[1]) }
    : iso
      ? { year: Number(iso[1]), month: Number(iso[2]), day: Number(iso[3]) }
      : null;

  return parsed && isCalendarDate(parsed) ? parsed : null;
}

export function fmtFactDate(value: unknown): string {
  if (typeof value !== "string") return "—";

  const parsed = parseFactDate(value);
  if (!parsed) return "—";

  const pad = (part: number) => String(part).padStart(2, "0");
  return `${pad(parsed.day)}.${pad(parsed.month)}.${String(parsed.year).padStart(4, "0")}`;
}
